import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@monorepo/shared/componentsV2/Button/IconButton';
import { Header } from '@monorepo/shared/componentsV2/Header';
import { ButtonAnchor } from '@monorepo/shared/componentsV2/Link';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import { useToast } from '@monorepo/shared/contexts';
import { getLinkToAdminFormTemplateEditor } from '@monorepo/shared/externalLinks/adminPanel';
import { useIsSuperAdmin } from '@monorepo/shared/hooks/permissions/useIsSuperAdmin';
import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import React, { FC, useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { useNavigate, useParams } from 'react-router-dom';
import { useCloseUrl } from '../shared/FormTemplateHeader';
import { StyledMain } from './styled';

function AdminFormTemplateEditorLink({
  formTemplateSlug,
}: {
  formTemplateSlug: string;
}) {
  const isSuperAdmin = useIsSuperAdmin();

  if (!isSuperAdmin || !formTemplateSlug) {
    return null;
  }

  const link = getLinkToAdminFormTemplateEditor({ formTemplateSlug });

  return (
    <ButtonAnchor
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      variant="text"
    >
      Admin Form Editor
    </ButtonAnchor>
  );
}

export const InvalidFormTemplateErrorPage: FC<FallbackProps> = ({ error }) => {
  useDisableSubnav();
  const closeUrl = useCloseUrl();
  const navigate = useNavigate();
  const { organizationId, formTemplateSlug } = useParams();

  if (!organizationId || !formTemplateSlug) {
    throw new Error(
      "InvalidFormTemplateErrorPage was rendered with a url that doesn't have organizationId or formTemplateSlug",
    );
  }

  const { showUserFriendlyErrorToast } = useToast();

  useEffect(() => {
    showUserFriendlyErrorToast(
      error,
      'There is a problem with this form that prevents it from being edited. Please reach out to your customer service representative.',
      { dontAutoHide: true },
    );
  }, [error, showUserFriendlyErrorToast]);

  return (
    <StyledMain>
      <Header
        title="Editing Form"
        leftActions={
          <IconButton onClick={() => navigate(closeUrl)}>
            <VisuallyHidden>Close</VisuallyHidden>
            <CloseIcon />
          </IconButton>
        }
        rightActions={
          <AdminFormTemplateEditorLink formTemplateSlug={formTemplateSlug} />
        }
      />
    </StyledMain>
  );
};
